var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{attrs:{"title":'Emitir Comprobante'}},[_c('Card',{attrs:{"noHeader":true}},[_c('Comprobante2')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }